$('#j-nav').click(() => {
  let body = $('body');

  if (body.hasClass('show-nav')) {
    body.removeClass('show-nav')
  } else {
    body.addClass('show-nav')
  }
})
$('#j-works-menu-btn').click(() => {
  let menu = $('#j-works-menu');

  if (menu.hasClass('p-works__tool-menu--close')) {
    menu.removeClass('p-works__tool-menu--close')
  } else {
    menu.addClass('p-works__tool-menu--close')
  }
})